<template>
  <div class="QR-page" v-if="$vuetify.breakpoint.width <= 768">
    <img class="ys-logo" src="/static/images/landing-page/ys_logo_primary-black.svg" />
    <div class="title" v-if="this.default && !this.ios && !this.android">Download the app <br> to create your account</div>
    <div class="options" v-if="this.default && !this.ios && !this.android">
      <div class="app-icon-container">
        <img
          src="/static/images/landing-page/apple-store.svg"
          aspect-ratio="1"
          height="84"
          width="187"
          @click="showQR('ios')"
          class="cursor-pointer"
        />
      </div>
      <div class="app-icon-container">
        <img
          src="/static/images/landing-page/google-play.svg"
          aspect-ratio="1"
          height="84"
          width="187"
          @click="showQR('android')"
          class="cursor-pointer"
        />
      </div>
    </div>

    <div class="options" v-if="this.ios || this.android">
      <div class="title" v-html="this.ios ? 'Download iOS App' : 'Download Android App'">
        </div>
        
      <div class="qr-code__content--img" style="margin-top: 20%; text-align: center;">
        <img
          v-if="this.ios"
          :src="require('@/assets/qr/qrcode_ios.png')"
          width="307"
        />

        <img
          v-if="this.android"
          :src="require('@/assets/qr/qrcode_android.png')"
          width="307"
        />
      </div>
    </div>

    <center v-if="this.ios || this.android" @click="reset"> Go back </center>
  </div>
  <div v-else>
    <v-container class="no-top-nav no-side-space">
      <v-layout align-center full-authTabs-wrapper justify-center row>
        <v-flex xs12 :class="{ onMobileStrict }">
          <div v-if="activeView === 'signUpView'" class="signup-view">
            <Onboarding />
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Footer from "../../components/landingPages/Footer-2.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import Onboarding from "@/views/mobile/auth/onboarding";

export default {
  name: "SignUpPage",
  components: {
    Footer,
    Onboarding,
  },
  data() {
    return {
      default: true,
      ios: false,
      android: false,
      activeView: "signUpView",
    };
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  computed: {
    ...mapState({
      musicFeed: (state) => state.trending.albums,
      currentSignUpStage: (state) => state.app.onboarding.current,
      signUpAccountCategory: (state) => state.app.onboarding.accountCategory,
    }),
    ...mapGetters({
      isAuthenticated: "auth/isAuthenticated",
      onMobileStrict: "app/onMobileStrict",
    }),
    onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    ...mapActions({
      getTrendingMusic: "trending/getTrendingMusic",
    }),
    checkScreenSize() {
      const screenWidth = window.innerWidth;
      if (screenWidth > 768) {
        this.$router.push('/');
      }
    },
    isActiveTab(tab) {
      return this.activeTab === tab;
    },
    showQR(input) {
      input === "ios" ? (this.ios = true) : (this.android = true);
    },
    reset() {
      this.ios = false;
      this.android = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.QR-page {
  background: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 15%;
  gap: 40px;
  min-height: 100vh;
}

.QR-page .title{
  color: #FFF;
  text-align: center;
  font-family: Outfit;
  font-size: 30px !important;
  font-style: normal;
  font-weight: 600;
  line-height: 34px !important;
  margin-bottom: 30px;
}

.QR-page .options {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.QR-page .options img {
  width: 231px;
}

.QR-page .ys-logo {
  height: 30px;
  margin-bottom: 15%;
}

.QR-page center {
  position: absolute;
  bottom: 0;
  color: #fff;
  font-size: 16px;
  margin-bottom: 50px;
  font-weight: 600;
  cursor: pointer;
}
.nav-slider {
  // background-color: #f7eeea;
  background-color: #000212;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;

  &.bg-white {
    background-color: white;
  }

  &.transparent {
    background-color: transparent;
  }

  .nav-flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 0;

    .nav-logo {
      width: 165px;
    }

    .nav-links {
      display: flex;
      align-items: center;
      gap: 35px;

      .black-btn {
        color: white;
        background-color: black;
        font-size: 18px;
        font-weight: bold;
        padding: 5px 7.5px;
      }

      a {
        color: white;
        font-weight: bold;
        font-size: 18px;
      }
    }
  }
}
.full-authTabs {
  &-container {
    // padding: 20px;
    position: fixed;
    width: 100%;
    top: 0;
    // min-height: 70vh;
  }

  &-twin {
    min-height: 100vh;
  }

  &-right {
    position: relative;
    padding-left: 20px;
    scrollbar-width: none;
    display: flex;
    align-items: center;
    // background-image: url(../../../../yousound-vue/static/images/banner-bg.png);
    background-position: center;

    &::before {
      content: "";
      background: radial-gradient(
        188.37% 478.1% at 50% 50%,
        #7877c6 0%,
        rgba(0, 0, 0, 0) 97.67%
      );
      filter: blur(134.492px);
      position: absolute;
      width: 1435.16px;
      height: 168.22px;
      left: 51px;
      top: 442.11px;
    }

    &::after {
      content: "";
      position: absolute;
      width: 343.46px;
      height: 158.59px;
      left: 450px;
      top: 75px;
      background: #106c93;
      filter: blur(165.158px);
    }

    &::-webkit-scrollbar {
      width: 2px;
      display: none;
    }

    &::-webkit-scrollbar-track {
      display: none;
    }

    &::-webkit-scrollbar-thumb {
      display: none;
    }

    &.onMobileStrict {
      padding-left: 0;
    }

    .cancel-icon-round {
      top: 26px;
    }

    &.auth__view {
      display: grid;
    }

    .trending {
      &-top {
        position: sticky;
        top: 0;
        z-index: 9;
        background-color: #ffffff;

        .trending-title {
          font-weight: 700;
          font-size: 24px;
          line-height: 40px;
          letter-spacing: -1px;
        }

        .top-menu {
          width: fit-content;
          width: -moz-fit-content;
        }
      }

      &-music {
        padding-right: 10px;
        padding-left: 10px;
      }
    }

    .login-view {
      margin: 0 auto;
      padding-top: 10%;

      .sign-up_logo {
        display: flex;
        justify-content: center;
        margin-bottom: 25%;
      }

      .intro-text h2 {
        font-size: 28px;
        font-weight: 500;
      }
    }

    .signup-view {
      width: 100%;
      height: 55%;
      padding-top: 10px;
      margin: 0 auto;

      .intro-text h2 {
        font-size: 28px;
      }

      .sign-up_logo {
        display: flex;
        justify-content: center;
        margin-bottom: 80px;
      }

      .onboarding {
        &.allowFullPage {
          width: 100%;
        }

        /deep/ .stager {
          position: relative;
        }

        /deep/ &_comp {
          &.profile-image {
            .profile-image-holder {
              margin-top: 40px;
              width: 200px;
              height: 200px;
            }
          }
        }

        /deep/ .auth-plan {
          position: relative;
          top: 0;
          left: 0;
          padding: 10px;
          width: 100%;
        }
      }
    }
    .login-view {
      width: 50%;
    }
  }
}

@media screen and (min-width: 1600px) {
  .container {
    max-width: 1300px;
  }
}

@media screen and (max-width: 479px) {
  .login-view {
    width: 100%;
    .intro-text {
      h2 {
        font-size: 40px;
        font-weight: 700;
        line-height: 40px;
        text-align: center;
        letter-spacing: -2px;
      }
    }

    .login-input {
      .form-icon {
        display: none;
      }
    }
  }
}

@media screen and (max-width: 1280px) {
  .no-top-nav {
    padding: 0px !important;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?705e3be6